<template>
  <div class="modal-backdrop">
    <div class="card col-lg-4 col-md-8 mt-md-4 col-11 p-0" :class="{'confirmCard' :displayConfirmationModal}" v-if="!displayAPIerrorModal">
      <div class="modal-content postmodalcontent" v-if="!displayConfirmationModal">
        <div class="modal-header p-4">          
          <h5 class="modal-title fontsize16 black80 proximanova-bold ml-2" id="exampleModalLabel">Report</h5><span class="tagLineReport mt-2 ml-2" >This post is not relevent or offensive</span>          
          <button type="button" class="close" @click="close('NOTSUCCESS')" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body bodymodal11">
          <span class="fontsize14 red proximanova">{{message}}</span>
          <div class="p-4">
            <div class="row opacityfont-12" >
              <form>
                <div class="form-check pb-2" v-for="(message,index) in reportmessages" :key="index" >
                  <label class="form-check-label" for="radio1">
                    <input type="radio" class="form-check-input check-with-label" :id="'radio1'+index" v-model="checkedValue"  checked name="radio1" :value="message.id" @click="handleClick(index)">
                    <!-- <span class="font14bold">{{message.indexDetailName}}</span> -->
                    <span class="d-flex flex-column">
                      <label class="proximanova-bold fontsize14 label-for-check pointer" :id="'report-message'+index"  @click="handleClick(index)">{{message.indexDetailName}}</label>
                      <div class="fontsize12 proximanova black60" v-if="index ===0">Misleading or repetitive posts</div> 
                      <div class="fontsize12 proximanova black60" v-else-if="index ===1">Violent images or promotion of violence</div> 
                      <div class="fontsize12 proximanova black60" v-else-if="index ===2">Sexually explicit content</div>
                      <div class="fontsize12 proximanova black60" v-else-if="index ===3">Prejudice, stereotypes, white supremacy, slurs</div>
                      <div class="fontsize12 proximanova black60" v-else-if="index ===4">Insults, threats, personally identifiable info</div>
                      <div class="fontsize12 proximanova black60" v-else>Health misinformation or conspiracies</div>
                    </span>
                  </label>                                      
                </div>
                <div class="row no-gutters p-3">
                  <div class="col d-flex justify-content-start align-items-center ">
                    <div class="form-group">                      
                      <textarea
                        class="form-control"
                        v-model="reportMessageText"
                        id="exampleFormControlTextarea1"                    
                        rows="5"
                        cols="77"
                        @input="addTextreport"
                        spellcheck="true"
                        maxlength="400"
                        placeholder="Repot Description (Optional)"
                      ></textarea>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-end pr-3 pt-3 pb-2">
                  <a  class="btn button-create btn-color mr-2 close-button borderradius20 mouseoverbtn1" id="follow" @click="close('NOTSUCCESS')">
                    <span class="fontsize16 black80 proximanova">Cancel</span>
                  </a>
                  <a   class="btn button-create backgroundcolorblack mouseoverbtn2 white borderradius20 mouseoverbtn1"  @click="openConfirmmodal" id="search">
                    <span class="bold16px_white proximanova">Report</span>
                  </a>
                </div>
              </form>                                                                       
            </div>
          </div>
        </div>
      </div>
      <div class="modal-content postmodalcontent" v-if="displayConfirmationModal">
        <div class="modal-header delete-modal pb-0">
          <h5 class="modal-title fontsize20 black80 proximanova" id="deleteLikeVideoModalLabel">Are you sure you want to report on this video ?</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="cancelConfirmmodal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body backgroundcolorwhite modal-delete text-center">
          <span class="borderradius20 button-cancel-font modaldeletebtn pointer mouseoverbtn1 border p-2 pr-4 pl-4 proximanova" @click="cancelConfirmmodal" data-dismiss="modal" aria-label="Close" >No</span>
          <button class="borderradius20 button-cancel-font backgroundcolorblack mouseoverbtn1 pointer white border p-1 ml-2 pr-4 pl-4 proximanova" :disabled="submitBtndisabled"  @click="reportvideo(reportmessage)">Yes</button>
        </div>
      </div>
    </div>
    <div class="card maincard col-lg-3 col-md-5 mt-md-4 col-10 p-0 borderadius12" v-else>
      <div class="modal-content postmodalcontent borderadius12">
        <div class="modal-body p-5 pb-5">
          <div class="d-flex flex-column text-center">
            <span class="proximanova-bold fontsize18 black">Error</span>
            <span class="mt-2 proximanova fontsize16 black60">Oops, Something went wrong.</span>
            <span class="mt-1 proximanova fontsize16 black60">Please try again later.</span>
            <button class="backgroundcolor3 white bordernone proximanova mt-4 p-1 borderadius12" @click="close('NOTSUCCESS')" data-dismiss="modal" aria-label="Close">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
import httpuserprofile from "@/js/http-userprofile.js";
import sessionUtils from '@/js/session-util.js'
export default{
   data() {
    return{
      Description : '',
      privacy : 'PUBLIC',
      videoplaying : false,
      profileId : null,
      videoId: null,
      reportmessages: [],
      reportMessageText: '',
      reportID: null,
      message : '',
      displayConfirmationModal : false,
      checkedValue : null,
      submitBtndisabled : false,
      displayAPIerrorModal : false,
    }
  },
  props : [
      'reportmessage'
  ],
  methods:{
    handleClick(ind){
      // this.reportID = this.reportmessages[ind].id;    
      this.checkedValue = this.reportmessages[ind].id;
      this.message = "";
      this.reportMessageText = ''
    },
    addTextreport : function() {
      this.checkedValue = '114';
    },
    cancelConfirmmodal(){
      this.displayConfirmationModal = false;
      this.submitBtndisabled = false;
    },
    openConfirmmodal() {
      if(this.checkedValue) {
        this.displayConfirmationModal = true;
      }else{
        this.message = "Please select report reason before submit"
      }
    },
    // reporting on a video
    reportvideo(video){
      // console.log(this.currentuserId)
      var vm = this;
      // var element = document.getElementById('')
      this.submitBtndisabled = true;
      var fd = new FormData(); 
        var obj = {
        profileId : this.reportmessage.currentuserId,
        videoId: video.id,
        // reportMessageId: this.reportID,
        reportMessageId : this.checkedValue,
        description: this.reportMessageText
      }
      console.log("submit : ", obj)
      var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      fd.append("userVideoReport", blob)
      console.log(obj)      
      httpuserprofile.post("/userprofile/reportVideo", fd, {
        headers: {
             "Content-Type": "multipart/form-data",
          "Accept" : "*/*"
        }
      }).then((response) => {
          console.log(response)
          this.submitBtndisabled = false;
          this.reportID = null;
          this.close('SUCCESS')
          vm.$toast.success("Successfully reported on a video")
       }).catch((e) => {
         this.submitBtndisabled = false;
         this.reportID = null;
        //  this.close('NOTSUCCESS')
         this.displayAPIerrorModal = true;
          setTimeout(() => {
            vm.close('NOTSUCCESS') 
          }, 5000);
        console.log(e)
      })    
    },
    close(type) {
        this.$emit('closereport', type);
      },
      //fetch report messages
    getReportMessages(){
      httpuserprofile
        .get("/userprofile/getListOfReasons")            
        .then(response => {              
          this.reportmessages = response.data.indexDetailsList;  
          console.log(this.reportmessages)            
        });   
    }

  },
   mounted() {
    this.profileId=sessionUtils.getUserProfileId();
    console.log("reportMessageBob : ", this.reportmessage)
    this.getReportMessages();
  },

}

</script>

<style scoped>
.modal-backdrop {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000 !important;
}
.card {
   padding: -5px !important;
}
label input[type="radio"]:checked ~ span {
    color: #007AFF;
}
.confirmCard{
  margin-top: 15% !important;
}
.postmodalcontent{
  border: none !important;
}
#follow{
	transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
    text-align: right;
   
  }
#follow::before {
	transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 10%;
	right : 10%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px !important;
	background-color :  rgba(31,31,31,.3);
  }
  #follow:hover:before {
    cursor: pointer;
	transition : 0.5s all ease;
	left : 0;
	right : 0;
    padding-left:5px;
	opacity : 1;
	z-index : -1;
    padding-bottom: 5px;    
    padding-right: 5px !important;
    padding-top: 5px !important;
    border-radius:4px;
  }
 
.close-button{
  border-color: #1F1F1F;
}
button:active {
    outline: none;
    border: none;
}
.btn:focus{
  box-shadow: none;
}
.modal-header{
  border: none;
}
.bodymodal11{
  padding: 0 4% !important;
  height: 520px;
  overflow-y: auto;
}
.close{
  padding: 1px 7px 5px 7px !important;
  /* margin-top: 0px !important; */
  margin-top: -3px !important;
  margin-right: 5px !important;
}
.close:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
ul{
  padding-inline-start: 0px !important;
}
.tagLineReport{
	height: 10px;
	color: #1F1F1F;
	font-size: 10px;
	font-weight: bold;
	letter-spacing: 0;
	font-style: italic;
  opacity: 60%
}
@media screen and  (max-width : 600px){
  .card{
    margin-left: 4%;
    margin-top: 4%;
  }
}
@media screen and  (min-width: 770px){
  .card{
    margin-left: 35%;
  }
}
@media screen and  (min-width: 600px) and (max-width : 768px){
  .card{
    margin-left: 15%;
  }
}
</style>